export default "__VITE_ASSET__a30f7c1a__"